import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { ToggleButtonStatusSubmenu } from "src/components";
import {
  ActiveTaskItemStatuses,
  ClosedTaskItemStatuses,
  TASK_ITEM_STATUSES,
  TaskItemsFilterByOption,
  TaskItemStatus,
} from "../../constants";

interface Props {
  filterByOption: TaskItemsFilterByOption;
  filterByStatusOptions: TaskItemStatus[] | null;
  onChange: (filterByOption: TaskItemsFilterByOption, filterByStatusOptions: TaskItemStatus[] | null) => void;
}

const TaskItemsFilterToggleButton = (props: Props) => {
  function handleFilterByChanged(value: TaskItemsFilterByOption) {
    // The status filter option should only be set after a status option is selected from the submenu
    if (value != null && value !== TaskItemsFilterByOption.Status) {
      props.onChange(value, null);
    }
  }

  function handleFilterByStatusChanged(values: TaskItemStatus[]) {
    if (values.length === 0) {
      props.onChange(TaskItemsFilterByOption.All, null);
      return;
    }

    props.onChange(TaskItemsFilterByOption.Status, values);
  }

  return (
    <>
      <ToggleButtonGroup
        value={props.filterByOption}
        exclusive
        orientation="vertical"
        variant="menu"
        onChange={(_, value) => handleFilterByChanged(value)}
        sx={{ minWidth: "100%" }}
      >
        <ToggleButton value={TaskItemsFilterByOption.All}>
          <Typography>All</Typography>
        </ToggleButton>

        <ToggleButtonStatusSubmenu
          value={TaskItemsFilterByOption.Status}
          statuses={TASK_ITEM_STATUSES}
          selectedStatusIds={props.filterByStatusOptions ?? []}
          activeStatusFilter={(status) => ActiveTaskItemStatuses.includes(status.id)}
          closedStatusFilter={(status) => ClosedTaskItemStatuses.includes(status.id)}
          onStatusSelected={(selectedStatusIds) => handleFilterByStatusChanged(selectedStatusIds)}
          menuProps={{
            anchorOrigin: {
              horizontal: "left",
              vertical: "top",
            },
            transformOrigin: {
              horizontal: "right",
              vertical: "top",
            },
          }}
        />
      </ToggleButtonGroup>
    </>
  );
};

export { TaskItemsFilterToggleButton };
